import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { AppService } from "../app.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "vpc-haz-isHighRiskOrStopWork",
  styles: [
    `
      .risk-card {
        border-radius: 4px;
        border: 1px solid #ddd;
        background: #fff; /* default white */
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 14px;
        width: 100%;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-bottom: 12px;
      }

      /* STOP unsafe work - selected */
      .risk-card.stop.selected {
        border: 1px solid #9f0014;
        background: #FFEEEE;
      }

      /* HIGH RISK - selected */
      .risk-card.high.selected {
        border: 1px solid #EF0015;
        background: #FFEEEE;
      }

      .risk-header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 600;
        font-size: 14px;
      }

      .risk-header.high {
        color: #ef0015;
      }

      .risk-header.stop {
        color: #9f0014;
      }

      .risk-header .title_row {
        display: flex;
        align-items: center;
      }

      .risk-header .inline_icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }

      .risk-text {
        font-size: 13px;
        color: #333;
        line-height: 18px;
        margin-left: 24px;
      }

      .hidden-radio {
        display: none;
      }

      .risk-card.disabled {
        pointer-events: none;
        opacity: 0.6; /* visual feedback */
      }
    `,
  ],
  template: `
    <div style="padding:10pt; background:#fff;">
      <!-- HIGH RISK card -->
      <div
        class="risk-card high"
        [class.selected]="formControl.value === 'high'"
        [class.disabled]="isDisabled"
        (click)="selectOption('high')"
      >
        <div class="risk-header high">
          <div class="title_row">
            <ion-icon name="warning-outline" class="inline_icon"></ion-icon>
             {{'SHIELD.OBSERVATION_HIGH_RISK'|translate}}
          </div>
        </div>
        <div class="risk-text">
        {{'SHIELD.OBSERVATION_HIGH_RISK_CARD_CONTENT'|translate}}
          
        </div>
        <input
          type="radio"
          class="hidden-radio"
          [formControl]="formControl"
          value="high"
        />
      </div>

      <!-- STOP UNSAFE WORK card -->
      <div
        class="risk-card stop"
        [class.selected]="formControl.value === 'stop'"
        [class.disabled]="isDisabled"
        (click)="selectOption('stop')"
      >
        <div class="risk-header stop">
          <div class="title_row">
            <img src="assets/img/bog_tour/rang_slider/stop_work.svg" alt="Stop Work Icon" class="inline_icon">
            {{'SHIELD.OBSERVATION_STOP_UNSAFE_WORK'|translate}}
          </div>
        </div>
        <div class="risk-text">
          {{'SHIELD.OBSERVATION_STOP_UNSAFE_WORK_CARD_CONTENT'|translate}}
        </div>
        <input
          type="radio"
          class="hidden-radio"
          [formControl]="formControl"
          value="stop"
        />
      </div>
    </div>
  `,
  standalone:false
})
export class VpcHazIsHighRiskOrStopWorkFormlyType extends FieldType {
  isDisabled: boolean = false;
  mode: string = "create";

  constructor(private appService: AppService, private route: ActivatedRoute) {
    super();
  }

  selectOption(value: string) {
    if (this.isDisabled) {
      return; // block selection when disabled
    }
    this.formControl.setValue(value);
  }

  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      this.mode = params["mode"];
    });

    if (this.mode == 'edit') {
      this.appService.bravoGoodPracticeCheckBox.subscribe(async (res) => {
        if (!res) return;

        if (res.name === "immediate_risk") {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      });
    }

    if (this.appService.editObservation.currentObservationInfo) {
      if (
        this.appService.editObservation.currentObservationInfo
          .isHighRiskOrStopWork != undefined
      ) {
        this.formControl.setValue(
          this.appService.editObservation.currentObservationInfo
            .isHighRiskOrStopWork
        );
      }
    }

    // Set HIGH RISK as default selection if no value is set
    if (!this.formControl.value) {
      this.formControl.setValue('high');
    }
  }
}
